import {
  GET_ANNOUNCEMENT_GOLBE,
  GET_ANNOUNCEMENT_GOLBE_SUCCESS,
  GET_ANNOUNCEMENT_GOLBE_ERROR,
  GET_ANNOUNCEMENT_GOLBE_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAnnouncementForGlobe = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANNOUNCEMENT_GOLBE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ANNOUNCEMENT_GOLBE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_ANNOUNCEMENT_GOLBE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ANNOUNCEMENT_GOLBE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAnnouncementForGlobe;
